<template>
  <div
    class="h-100 w-100pc bg-white bb-1 bc-extra-light-gray bottom-200 pa-4"
    data-cy="message-thread-header"
  >
    <div class="d-flex align-center mb-2">
      <v-btn
        v-if="display.smAndDown"
        @click="$emit('back')"
        :size="!display.mdAndUp && 'small'"
        class="c-black me-2"
        icon="west"
        variant="text"
      />

      <div
        :class="titleClass"
        class="d-inline-block"
      >
        {{ $bct(noTranslate ? title : $bct(title)) }}
      </div>
    </div>

    <v-btn
      v-if="isAssessment()"
      :active="false"
      :class="subtitleClass"
      :to="{ name: 'AssessmentShow', params: { assessmentId: assessment.id } }"
      append-icon="open_in_new"
      class="c-light-black"
      data-testid="message-assessment-btn"
      variant="text"
    >
      {{ $bct(noTranslate ? subtitle : $bct(subtitle)) }}
    </v-btn>

    <div
      v-else
      :class="subtitleClass"
      class="c-light-black"
    >
      {{ $bct(noTranslate ? subtitle : $bct(subtitle)) }}
    </div>
  </div>
</template>

<script setup>
import { useDisplay } from 'vuetify';

const display = useDisplay();
const $bct = inject('translator');

const props = defineProps({
  assessment: {
    type: Object,
    default: null,
  },
  noTranslate: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});

defineEmits(['back']);

const subtitleClass = computed(() => {
  return display.mdAndUp.value ? 'fs-16' : 'fs-14';
});

const titleClass = computed(() => {
  return display.mdAndUp.value ? 'fs-22 fw-600' : 'fs-18 fw-600';
});

// Replace in ref with just 'assessment'?
function isAssessment() {
  return props.assessment;
}
</script>
